import { Heading } from '@/components/ui/Heading'
import { Text } from '@/components/ui/Text'
import { cn } from '@/lib/utils'
import type { ImportStepHeaderProps } from '@/types/components/audiences/import-shell'

/**
 * Compact step header for the import wizard surfaces.
 * in import wizard pages. Renders a title and an optional one-line helper.
 */
export function ImportStepHeader({
  title,
  helper,
  headingLevel = 2,
  titleAction,
  className,
}: ImportStepHeaderProps) {
  return (
    <header className={cn('space-y-1', className)}>
      <div className="flex items-center gap-2">
        <Heading level={headingLevel}>
          {title}
        </Heading>
        {titleAction}
      </div>
      {helper ? (
        <Text size="sm" color="muted">
          {helper}
        </Text>
      ) : null}
    </header>
  )
}
